import { PlayCircle } from 'lucide-react';
import { VideoLightbox } from '@/components';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

interface AdvisorNotVerifiedContentProps {
  showVideoModal: boolean;
  onVideoModalChange: (show: boolean) => void;
}

export function AdvisorNotVerifiedContent({
  showVideoModal,
  onVideoModalChange,
}: AdvisorNotVerifiedContentProps) {
  const DEMO_VIDEO_URL = 'https://www.loom.com/embed/49a4f641f8a44840be0a678bfbf9351e';

  return (
    <div
      id="verification-required-content"
      className="bg-primary-50 flex h-full w-full px-4 pb-12 pt-3 sm:px-6 lg:px-8"
    >
      <div className="mx-auto w-full max-w-4xl">
        <Card className="mt-14 rounded-lg border p-8">
          <CardContent className="flex flex-col gap-6 p-0">
            {/* Header Section */}
            <div className="space-y-4">
              <h1 className="text-primary-dark text-4xl font-semibold">Welcome to Waterlily!</h1>
              <div className="text-primary-dark space-y-4 text-base leading-6 text-opacity-70">
                <p>
                  Before we hand you the reigns we're running some verifications on your
                  professional credentials.
                  <strong className="text-primary-dark text-opacity-90">
                    {' '}
                    This is usually done in minutes, up to 24 hours max.
                  </strong>
                </p>
                <p>
                  We'll email you once you're verified and you have full access! Meanwhile, get
                  ready with this quick-start video and book your live onboarding session with our
                  team to tailor Waterlily to your needs.
                </p>
              </div>
            </div>

            {/* CTA Section */}
            <div className="flex flex-col gap-4 pt-4 sm:flex-row sm:justify-end sm:gap-3">
              <Button
                onClick={() => onVideoModalChange(true)}
                variant="outline"
                className="h-12 w-full sm:w-48"
              >
                <PlayCircle className="mr-2 h-4 w-4" />
                Watch Demo
              </Button>
              <a
                href="https://calendly.com/d/cxdy-x3d-cqj/waterlily-onboarding-and-training"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-48"
              >
                <Button className="h-12 w-full">Book Onboarding</Button>
              </a>
            </div>

            <VideoLightbox
              videoUrl={`${DEMO_VIDEO_URL}?t=0s`}
              isOpen={showVideoModal}
              onOpenChange={onVideoModalChange}
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
